import React from 'react'
import './PatientCards.scss'
import PropTypes from 'prop-types'
import { CRow, CCol, CCard } from '@coreui/react-pro'
import { dateUSFormat } from '../../../../../../../../utils/dateTimeUtils'
import { getProviderInitials } from '../../../../../../../../utils/sharedFunctions'
import { STATUS_GROUPS } from '../../../../../../../../utils/statusConstants'

const PatientCards = ({ patient }) => {
  return (
    <CCard className="patient-card mb-2 px-2 py-1">
      <CRow className="w-100 align-items-center">
        <CCol sm="auto p-2">
          {patient?.statusGroup === STATUS_GROUPS.completed && (
            <i className="fa-solid fa-circle text-success" style={{ fontSize: '0.8em' }}></i>
          )}
          {patient?.statusGroup === STATUS_GROUPS.in_complete && (
            <i className="fa-solid fa-circle text-danger" style={{ fontSize: '0.8em' }}></i>
          )}
          {patient?.statusGroup === STATUS_GROUPS.available && (
            <i className="fa-light fa-circle" style={{ fontSize: '0.8em' }}></i>
          )}
        </CCol>
        <CCol className="column-one text-truncate ps-0">
          <span className="fs16 fw-bolder">{patient?.patient_lastname}, </span>
          <span className="fs16">{patient?.patient_firstname}</span>
          <br />
          {patient?.room && <small className="me-1">{patient?.room} |</small>}
          <span className="diagnosis-code">{patient?.diagnosis_code_primary?.code}</span>
          <span className="diagnosis-description">
            &nbsp;-&nbsp;{patient?.diagnosis_code_primary?.description}
          </span>
        </CCol>
        <CCol sm="auto" className="column-two text-truncate">
          <span className="code">{patient?.procedure_code_primary?.code || '-'} </span>
          <span className="admission">{getProviderInitials(patient?.rendering_provider_name)}</span>
          <br />
          {patient?.service_date_from && (
            <span className="admission">{dateUSFormat(patient?.service_date_from)}</span>
          )}
        </CCol>
      </CRow>
    </CCard>
  )
}

PatientCards.propTypes = {
  patient: PropTypes.any,
}
export default PatientCards
